/**
 *
 */
export type TraceFlags = [
  number,
  number,
  number,
  number,
  number,
  number,
  number,
  isSampled: number,
];

/**
 *
 *
 *
 *
 *
 *
 */
export const parseTraceparentFlags = (flags: string | undefined): TraceFlags => {
  const res = [0, 0, 0, 0, 0, 0, 0, 0] as TraceFlags;

  /*                                                                    */
  if (!flags || flags.length !== 2) return res;

  /*                                                           */
  const byte = parseInt(flags, 16);
  if (isNaN(byte)) return res;

  /*                                                   */
  res.forEach((_, i) => (res[i] = (byte >> (7 - i)) & 1));

  return res;
};
